import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Text, Badge } from "@fluentui/react-components";
import { BookOpenRegular } from "@fluentui/react-icons";
import { ManagerSideNav } from "./ManagerSideNav";
import { EmployeeDashboard } from "../views/Employee/EmployeeDashboard";
import { MyAbsences } from "../views/Employee/MyAbsences";
import { MyBadgeage } from "../views/Employee/MyBadgeage";
import { MyService } from "../views/Employee/MyService";
import { MyInfo } from "../views/Employee/MyInfo";
import { MyParcours } from "../views/Employee/MyParcours";
import { HelpContact } from "../views/Employee/HelpContact";
import { ManagerEquipeDashboard } from "../views/Manager/ManagerEquipeDashboard";
import { ManagerEquipeMembres } from "../views/Manager/ManagerEquipeMembres";
import { ManagerEquipePlanning } from "../views/Manager/ManagerEquipePlanning";
import { useAuth } from "../../context/AuthContext";
import { useRole } from "../../context/RoleContext";
import { FormationProvider } from "../Formation/FormationContext";
import { TourGuide } from "../Formation/TourGuide";
import { FormationCenter } from "../Formation/FormationCenter";
import { RoleSwitcher } from "../common/RoleSwitcher";
const ManagerLayoutInner = () => {
    const [activeView, setActiveView] = useState("dashboard");
    const [showFormation, setShowFormation] = useState(false);
    const { userName, userEmail } = useAuth();
    const { role } = useRole();
    const renderView = () => {
        switch (activeView) {
            // Mon espace
            case "dashboard": return _jsx(EmployeeDashboard, {});
            case "absences": return _jsx(MyAbsences, {});
            case "badgeage": return _jsx(MyBadgeage, {});
            case "service": return _jsx(MyService, {});
            case "infos": return _jsx(MyInfo, {});
            case "parcours": return _jsx(MyParcours, {});
            case "aide": return _jsx(HelpContact, {});
            // Mon équipe
            case "equipe-dashboard": return _jsx(ManagerEquipeDashboard, {});
            case "equipe-planning": return _jsx(ManagerEquipePlanning, {});
            case "equipe-membres": return _jsx(ManagerEquipeMembres, {});
        }
    };
    return (_jsxs("div", { style: { display: "flex", minHeight: "100vh", width: "100%" }, children: [_jsx(ManagerSideNav, { activeView: activeView, onNavigate: setActiveView }), _jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column" }, children: [_jsxs("header", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 32px",
                            borderBottom: "1px solid #e0e0e0",
                            backgroundColor: "#fff",
                        }, children: [_jsx(Text, { size: 400, weight: "semibold", style: { color: "#0066cc" }, children: "AVH - Espace Responsable" }), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [_jsx(Button, { size: "small", appearance: "subtle", icon: _jsx(BookOpenRegular, {}), onClick: () => setShowFormation(true), title: "Aide", children: "Aide" }), _jsx(RoleSwitcher, {}), _jsx(Badge, { appearance: "outline", color: "brand", children: role }), _jsxs(Text, { size: 200, children: [userName, " (", userEmail, ")"] })] })] }), _jsx("main", { style: { flex: 1, padding: "24px 32px", overflow: "auto" }, children: showFormation ? (_jsx(FormationCenter, { portailType: "Salarie", onClose: () => setShowFormation(false), onNavigate: (view) => { setActiveView(view); setShowFormation(false); } })) : (renderView()) })] }), _jsx(TourGuide, {})] }));
};
export const ManagerLayout = () => (_jsx(FormationProvider, { portailType: "Salarie", children: _jsx(ManagerLayoutInner, {}) }));
